var _defs, _g, _g2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJavascriptLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 37.5 37.499999",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d11e96e2a5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 37.007812 0 L 37.007812 37.007812 L 0 37.007812 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bdad622f73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.636719 6.636719 L 30.636719 6.636719 L 30.636719 30.636719 L 6.636719 30.636719 Z M 6.636719 6.636719 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d11e96e2a5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 37.5 0 L 37.5 45 L 0 45 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 37.5 0 L 37.5 37.5 L 0 37.5 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M 0 0 L 37.5 0 L 37.5 37.5 L 0 37.5 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bdad622f73)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7df1e",
    d: "M 6.636719 6.636719 L 30.636719 6.636719 L 30.636719 30.636719 L 6.636719 30.636719 Z M 6.636719 6.636719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 12.949219 26.695312 L 14.785156 25.582031 C 15.140625 26.210938 15.460938 26.742188 16.234375 26.742188 C 16.976562 26.742188 17.441406 26.453125 17.441406 25.324219 L 17.441406 17.65625 L 19.699219 17.65625 L 19.699219 25.355469 C 19.699219 27.691406 18.328125 28.757812 16.332031 28.757812 C 14.527344 28.757812 13.480469 27.820312 12.949219 26.695312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 20.921875 26.453125 L 22.757812 25.386719 C 23.242188 26.179688 23.871094 26.757812 24.984375 26.757812 C 25.917969 26.757812 26.511719 26.292969 26.511719 25.644531 C 26.511719 24.871094 25.902344 24.597656 24.871094 24.148438 L 24.304688 23.90625 C 22.679688 23.214844 21.601562 22.34375 21.601562 20.507812 C 21.601562 18.816406 22.886719 17.527344 24.902344 17.527344 C 26.335938 17.527344 27.367188 18.027344 28.109375 19.332031 L 26.351562 20.460938 C 25.964844 19.765625 25.546875 19.492188 24.902344 19.492188 C 24.242188 19.492188 23.824219 19.910156 23.824219 20.460938 C 23.824219 21.136719 24.242188 21.410156 25.207031 21.828125 L 25.773438 22.070312 C 27.6875 22.890625 28.769531 23.730469 28.769531 25.613281 C 28.769531 27.644531 27.175781 28.757812 25.03125 28.757812 C 22.9375 28.757812 21.585938 27.757812 20.921875 26.453125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascriptLogo);
export default __webpack_public_path__ + "static/media/JavascriptLogo.4e5d1745bf7d3c34f639c09b4c773fce.svg";
export { ForwardRef as ReactComponent };